<template>
	<div class="footerContainer">
		<div style="width: 100%;height: 268px;background: #0B294D;">
			<div
				style="display: flex;align-items: center;justify-content: space-between;  width: 1200px;margin: 0 auto;height: 60px;border-bottom: 1px solid rgba(255, 255, 255, 0.25);">
				<div style="display: flex;width: 630px;height: 30px;">
					<div @click="goToPath('/')" :class="currentUrl=='/'?'indexItems':'textHover'" style="cursor: pointer; color: rgba(255, 255, 255, 0.65);font-size: 14px;">
						首页
					</div>
					<div @click="goToPath('/centerLab')" :class="currentUrl=='/centerLab'||currentBigUrl=='center'?'indexItems':'textHover'" style="margin-left: 48px; cursor: pointer; color: rgba(255, 255, 255, 0.65);font-size: 14px;">
						中心实验室
					</div>
					<div @click="goToPath('/animalLab')" :class="currentUrl=='/animalLab'||currentBigUrl=='animal'?'indexItems':'textHover'" style="margin-left: 48px; cursor: pointer; color: rgba(255, 255, 255, 0.65);font-size: 14px;">
						动物实验中心
					</div>
					<div @click="goToPath('/pointLab')" :class="currentUrl=='/pointLab'?'indexItems':'textHover'" style="margin-left: 48px; cursor: pointer; color: rgba(255, 255, 255, 0.65);font-size: 14px;">
						省重点实验室
					</div>
					<div @click="goToPath('/orderLab')" :class="currentUrl=='/orderLab'?'indexItems':'textHover'" style="margin-left: 48px; cursor: pointer; color: rgba(255, 255, 255, 0.65);font-size: 14px;">
						其他科研平台
					</div>
				</div>
				<a-select default-value="友情链接" style="width: 170px;">
					<a-select-option :value="item.linkName" v-for="(item,index) in logoBannerData.link"
						@click="goToLink(item.linkUrl)">
						{{item.linkName}}
					</a-select-option>
				</a-select>
			</div>
			<div
				style="display: flex;align-items: center;justify-content: space-between;  width: 100%;margin: 0 auto;height: 158px;border-bottom: 1px solid rgba(255, 255, 255, 0.25);">
				<div style="width: 1200px;margin: 0 auto;display: flex;justify-content: space-between;">
					<div style=" display: flex;flex-direction: column;">
					
					
						<div style="display: flex;">
							<p class="title_b" style="color: #FFFFFF;font-size: 14px;">电话：</p>
							<p class="title_b">{{logoBannerData.contactPhone}}</p>
						</div>
						<div style="display: flex;">
							<p class="title_b" style="color: #FFFFFF;font-size: 14px;">邮箱：</p>
							<p class="title_b">{{logoBannerData.fax}}</p>
						</div>
						<div style="display: flex;">
							<p class="title_b" style="color: #FFFFFF;font-size: 14px;">地址：</p>
							<p class="title_b">{{logoBannerData.address}}</p>
						</div>
					
					</div>
					<img :src="logoBannerData.logo2" style="width:230px;height: 80px;">
				</div>
				
			</div>


			<!-- <a-select default-value="友情链接" style="width: 170px;">
					<a-select-option :value="item.linkName" v-for="(item,index) in logoBannerData.link"
						@click="goToLink(item.linkUrl)">
						{{item.linkName}}
					</a-select-option>
				</a-select> -->
			<!-- 	</div> -->
		</div>
		<!-- <div
			style=" position: relative; display: flex;justify-content: space-around;align-items: flex-start;background: #0B294D;height: 268px;">
			<div
				style="display: flex;flex-direction: column;justify-content: space-between;height: 120px;padding-top: 76px;">
				<img :src="logoBannerData.logo2" style="width:170px;top: 15px;">
				<a-select default-value="友情链接" style="width: 170px;margin-top: 10px;">
					<a-select-option :value="item.linkName" v-for="(item,index) in logoBannerData.link"
						@click="goToLink(item.linkUrl)">
						{{item.linkName}}
					</a-select-option>


				</a-select>
			</div>
			<div style="height: 200px;width:450px;display: flex;flex-wrap: wrap;margin-top: 80px;">
				<a-col :span="8" v-for="(item,index) in menuItems">
					<a @click="linkHover(item.url)" style="font-size: 15px;cursor: pointer;color: #99989D;"
						class="linkHover">{{item.name}}</a>

				</a-col>
				<a-col :span="8" v-if="showTrain==true">
					<a @click="linkHover('/trainSign')" style="font-size: 15px;cursor: pointer;color: #99989D;"
						class="linkHover">培训报名</a>
				</a-col>
			</div>
		
			<div style="display: flex;flex-direction: column;margin-top: -30px;padding-top: 90px;">

				<p class="title_t">联系我们</p>
				<div style="display: flex;">
					<p class="title_b">联系电话：</p>
					<p class="title_b">{{logoBannerData.contactPhone}}</p>
				</div>
				<div style="display: flex;">
					<p class="title_b">邮箱：</p>
					<p class="title_b">{{logoBannerData.fax}}</p>
				</div>
				<div style="display: flex;">
					<p class="title_b">地址：</p>
					<p class="title_b">{{logoBannerData.address}}</p>
				</div>

			</div>
			<div style="display: flex;flex-direction: column;padding-top: 90px;">
				<p class="title_t">关注公众号</p>
				<img style="width: 120px;height: 120px;" :src="logoBannerData.officialAccount">
			</div>
		</div> -->
		<!-- <div
			style="padding: 22px 0pt; height: 40px;background: #082140;display: flex;justify-content: center;align-items: center;">
			<div style="display: flex;">
				<p style="color: #B8B8B8;font-size: 0.875rem;margin: 0;margin-right: 80px;">
					{{logoBannerData.copyright}}
				</p>
				<p style="color: #B8B8B8;font-size: 0.875rem;margin: 0;">
					{{logoBannerData.technicalSupport}}
				</p>
			</div>
		</div> -->
	</div>
</template>

<script>
	import {
		scrollAnimation
	} from '../../utils/js/scrollAnimation.js';
	import {
		logoBanner,
		SelIsShowTrain
	} from '@/api/index.js'
	export default {
		name: 'Home',
		components: {

		},

		data() {
			return {
				currentUrl: '',
				currentBigUrl:window.localStorage.getItem('currentBigUrl'),
				showTrain: true,
				logoBanner,
				logoBannerData: [],
				menuItems: [{
						name: '首页',
						url: '/'
					},
					{
						name: '平台简介',
						url: '/centerProfile'
					},
					{
						name: '科研服务',
						url: '/scientific'
					},
					{
						name: '公告资讯',
						url: '/notice'
					},
					{
						name: '下载中心',
						url: '/downLoad'
					},
					{
						name: '服务指南',
						url: '/guide'
					},
					{
						name: '仪器预约',
						url: '/instrument'
					},
					{
						name: '场地预约',
						url: '/operationRoom'
					},
					{
						name: '耗材&项目',
						url: '/consumable'
					},
					// {
					// 	name:'培训报名',
					// 	url:'/trainSign'
					// },
					{
						name: '考试中心',
						url: '/exam'
					},
				]
			}
		},
		watch: { //动态监听路由变化 -以便动态更改导航背景色事件效果等
			'$route'(to, from) {
				// 对路由变化作出响应...
				let current1 = this.$route.path
				
				this.currentUrl = current1
				console.log(this.currentUrl)
				this.currentBigUrl = window.localStorage.getItem('currentBigUrl')
				
				
				
			}
		},
		created() {
			this.getLogoBanner()
			SelIsShowTrain().then((res) => {
				this.showTrain = res.data.state
			})
		},
		
		methods: {
			goToPath(data) {
				// this.currentBigUrl = ''
				// window.localStorage.setItem('currentBigUrl',this.currentBigUrl)
				this.$router.push({
					path: data
				})
			},
			async getLogoBanner() {
				const res = await logoBanner()
				this.logoBannerData = res.data.data
				
			},
			goToLink(url) {
				if(url=='#'){
					// location.reload()
					return
				}
				window.open(url, "_blank")
				location.reload()
			},
			linkHover(url) {
				const currentY = document.documentElement.scrollTop || document.body.scrollTop
				scrollAnimation(currentY, 0)
				this.$router.push({
					path: url
				})
			}
		}
	}
</script>

<style scoped>
	.footerContainer {
		
	}

	.linkHover:hover {
		color: #40A9FF !important;
	}

	.title_t {
		font-style: normal;
		font-weight: normal;
		font-size: 1rem;
		color: #8E8E8E;
		margin: 1.175rem 0;
		display: block;
	}

	.title_b {
		font-size: 0.875rem;
		color: #99989D;
	}

	.textHover:hover {
		color: #1890FF !important;

	}
	.indexItems{
		color: white !important;
	}
	.textHover:hover{
		opacity: 0.8 !important;
	}
</style>
<style>
	.footerContainer .ant-select-selection--single {
		background-color: #2F4968 !important;
		border-color: transparent !important;
		color: rgba(255, 255, 255, 0.65) !important;
	}

	.footerContainer .ant-select-arrow-icon {
		color: rgba(255, 255, 255, 0.65) !important;
	}
</style>
